import classes from "./radio.module.scss";

export default function StandardRadioButton({ selected, className }) {
  return (
    <div
      className={`${classes.button} standardRadioButton ${
        selected ? `${classes.active} standardRadioButton--active` : ""
      } ${className}`}
    />
  );
}
